export const FEATURED_ITEMS_LOAD = 'FEATURED_ITEMS_LOAD';
